<template>
  <button
    v-show="!functionExecuted"
    class="flow-btn w3-btn w3-round w3-border w3-margin-right"
    @click="callback"
  >
    <i v-bind:class="iconAndColor()">
      <span v-if="this.text !== ''"
        ><b class="flow-margin-left">{{ $t(this.text) }}</b></span
      >
    </i>
  </button>
  <button
    v-show="functionExecuted"
    class="flow-btn w3-btn w3-round w3-border w3-ripple w3-margin-right"
  >
    <i v-bind:class="iconAndColor()">
      <span v-if="this.text !== ''"
        ><b class="flow-margin-left">{{ $t(this.text) }}</b></span
      >
    </i>
  </button>
</template>

<script>

export default {
  name: "QButton",
  props: {
    /**
     * callback function
     */
    callback: {
      type: Function,
      required: true,
    },
    functionExecuted: {
      type: Boolean,
      required: false,
      default: false,
    },
    text: {
      type: String,
      required: false,
      default: "",
    },
    icon: {
      type: String,
      required: false,
      default: "",
    },
    color: {
      type: String,
      required: false,
      default: "",
    },
  },
  methods: {
    iconAndColor() {
      return this.icon + " " + this.color;
    }
  },
};
</script>

<style scoped></style>
